import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7590b29a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mb-5"
}
const _hoisted_2 = {
  key: 3,
  class: "emptyText"
}

import { withDefaults, watch, computed } from 'vue';
import { MoleculeCard } from '@/components/molecules';
import { AtomProgressBar, AtomToogleButton, AtomProgressForm } from '@/components/atoms';
import VueHighcharts from 'vue3-highcharts';
import { IDataChart, IOptionsSelect, IProgress, IStep, IToggleButon } from '@/types';

interface IProps {
  title: string;
  legend?: boolean;
  isSteps: boolean;
  data: Array<IDataChart>;
  type: string;
  textX?: string;
  textY?: string;
  progress?: Array<IProgress>;
  hasToggle?: boolean;
  buttons?: IToggleButon[];
  hasDropdownList?: boolean;
  optionsDropDown?: IOptionsSelect[];
  colorSeries?: string;
  height?: number;
  steps?: IStep[]
  currentStep?: string
  loading?: boolean
  isCalendarSelect?: boolean
  textEmpty?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganismsChartSaltos',
  props: {
    title: { default: '' },
    legend: { type: Boolean, default: true },
    isSteps: { type: Boolean, default: false },
    data: null,
    type: null,
    textX: null,
    textY: null,
    progress: null,
    hasToggle: { type: Boolean, default: false },
    buttons: null,
    hasDropdownList: { type: Boolean },
    optionsDropDown: null,
    colorSeries: { default: '#000' },
    height: null,
    steps: null,
    currentStep: null,
    loading: { type: Boolean },
    isCalendarSelect: { type: Boolean, default: false },
    textEmpty: null
  },
  emits: ['handleToggle', 'onChangeDropDownList'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, legend: boolean, isSteps: boolean, data: Array<IDataChart>, type: string, textX?: string, textY?: string, progress?: Array<IProgress>, hasToggle: boolean, buttons?: IToggleButon[], hasDropdownList?: boolean, optionsDropDown?: IOptionsSelect[], colorSeries: string, height?: number, steps?: IStep[], currentStep?: string, loading?: boolean, isCalendarSelect: boolean, textEmpty?: string };



// const chartOptions = {
//   chart: {
//     type: props.type,
//   },
//   title: {
//     text: '',
//   },
//   xAxis: {
//     categories: props.data.map((f) => f.title),
//   },
//   yAxis: {
//     title: {
//       text: props.textY,
//     },
//   },
//   plotOptions: {
//     series: {
//       borderRadius: 18,
//     },
//   },
//   series: [
//     {
//       name: props.textX,
//       data: props.data.map((f) => f.value),
//     },
//   ],
// };
let chartOptions = {};
changeChartOptions();
function changeChartOptions() {
  chartOptions = {
    chart: {
      type: props.type,
      height: props.height,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories: props.data.map((f) => f.title),
    },
    yAxis: {
      title: {
        text: props.textY,
      },
    },
    plotOptions: {
      series: {
        borderRadius: 18,
      },
    },
    series: [
      {
        showInLegend: props.legend,
        name: props.textX,
        data: props.data.map((f) => f.value),
        color: props.colorSeries,
      },
    ],
  };
}
function handleToogleChange($event) {
  emit('handleToggle', $event);
}
function handleChangeDropdownList(event) {
  emit('onChangeDropDownList', event);
}

const isEmpty = computed(() => {
  return (props.steps ?? []).length == 0;
});

watch(
  () => props.data,
  () => {
    changeChartOptions();
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createBlock(_unref(MoleculeCard), {
    loading: props.loading,
    textTooltip: 'textTooltip',
    title: props.title,
    onOnChangeDropDownList: handleChangeDropdownList,
    "has-dropdown-list": props.hasDropdownList,
    "options-drop-down": props.optionsDropDown,
    isCalendarSelect: props.isCalendarSelect
  }, {
    default: _withCtx(() => [
      (props.hasToggle && !_unref(isEmpty))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(AtomToogleButton), {
              buttons: props.buttons ?? [],
              onHandleToggle: handleToogleChange
            }, null, 8, ["buttons"])
          ]))
        : _createCommentVNode("", true),
      (props.isSteps && !_unref(isEmpty))
        ? _renderSlot(_ctx.$slots, "bodySteps", { key: 1 })
        : _createCommentVNode("", true),
      (!props.isSteps && !_unref(isEmpty))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_unref(VueHighcharts), {
              type: "chart",
              options: _unref(chartOptions),
              redrawOnUpdate: true,
              oneToOneUpdate: false,
              animateOnUpdate: true
            }, null, 8, ["options"]),
            _createVNode(_component_v_divider, { class: "border-opacity-50 mb-6" }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.progress, (col, index) => {
              return (_openBlock(), _createBlock(_unref(AtomProgressBar), {
                key: String(index),
                modelValue: col.value,
                "progress-color": col.color,
                hasPercent: col.hasPercent,
                hasTitle: !!col.title,
                title: col.title,
                "has-percent-title": col.hasPercentTitle,
                max: col.maxValue
              }, null, 8, ["modelValue", "progress-color", "hasPercent", "hasTitle", "title", "has-percent-title", "max"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isEmpty) && props.textEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(props.textEmpty), 1))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }, 8, ["loading", "title", "has-dropdown-list", "options-drop-down", "isCalendarSelect"]))
}
}

})